import {
  Button,
  Checkbox,
  CircularProgress,
  Divider,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  Select,
  TextField,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ArrowBackIos } from '@material-ui/icons';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import Typography from '@mui/material/Typography';
import html2pdf from 'html2pdf.js';
import React, { useEffect, useRef, useState } from 'react';
import BlueButton from '../components/button/BlueButton';
import authService from '../Services/auth/auth-service';
import vistoriaService from '../Services/Vistoria/vistoria-service';
import { AvlLatariaVistoria } from './components/vistoria-tec/avl-lataria-vistoria-component';
import { AvlPreliminarVistoria } from './components/vistoria-tec/avl-preliminar-vistoria-component';
import { VistoriaItems } from './components/vistoria-tec/vistoria-items-component';
import { ListaProdutosServicos } from './components/vistoria/lista-produtos-component';
import veiculoService from '../Services/Veiculo/veiculo-service'; 

const useStyles = makeStyles((theme) => ({
  actions: {
    padding: '0 6px',
    marginBottom: 6,
  },
  paper: {
    marginBottom: 20,
    display: 'flex',
    flexDirection: 'column',
    padding: '15px 20px 15px',
    borderRadius: 10,
    [theme.breakpoints.down('sm')]: {
      padding: '15px 10px',
    },
  },
  tituloStyle: {
    fontFamily: 'Mont, sans-serif',
    color: '#209BDE',
    fontSize: '22px',
    textAlign: 'start',
    padding: '0 0px',
    marginBottom: '5px'
  },
  subtituloStyle: {
    fontFamily: 'Mont, sans-serif',
    color: '#7F7F7F',
    fontSize: '16px',
    fontWeight: 'inherit',
    textAlign: 'start',
    padding: '0 0px',
    marginTop: '0px'
  },
  title: {
    fontSize: 23,
    fontWeight: 'bold',
    marginBottom: 10,
    marginTop: 50
  },
  subtitle: {
    fontSize: 19,
    fontWeight: 'bold',
    marginTop: 40,
    marginBottom: 20,
  },
  radioP: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  radioTitle: {
    fontSize: 16,
    marginRight: 10,
  },
  itemText: {
    fontSize: 18,
  },
  errorText: {
    color: '#FF0000',
  },
}));

export function OSVistoriaPageTecnico({ ordemServico, handleBack, itensOS, nomeTecnico }) {
  const classes = useStyles();
  const [vistoria, setVistoria] = useState(null);
  const [ , setEditVistoria] = useState(false);
  const [disabledEditEntry, setDisabledEditEntry] = useState(false);
  const [disabledEditExit, setDisabledEditExit] = useState(false);
  const [loadVistoria, setLoadVistoria] = useState(false);
  const [errors,  ] = useState({});
  const [ , setAbrirAlert] = useState(false);
  const [ , setMensagemAlert] = useState('');
  const classificacaoPrestador = authService.getUserInfo().usuario.classificacaoPrestador;
  const placaLookupDoneRef = useRef(false);
  const inputRef = useRef(null);
  const locais = ['Volante', 'Ponto fixo'];

  const URL_LOGO = ''
  const URL_WAVE = 'data:image/png;base64,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'

  useEffect(() => {
    getVistoria();
  }, [ordemServico]);
  useEffect(() => {
  const placa = vistoria?.placa || ordemServico?.placa;

  // evita rodar várias vezes
  if (!placa || placaLookupDoneRef.current) return;

  // só busca se ainda não tem ano/cor preenchidos
  const jaTemAnoCor = !!vistoria?.ano && !!vistoria?.cor;
  if (jaTemAnoCor) {
    placaLookupDoneRef.current = true;
    return;
  }

  placaLookupDoneRef.current = true;
  preencherAnoCorPorPlaca(placa);
}, [vistoria?.placa, vistoria?.ano, vistoria?.cor, ordemServico?.placa]);

  async function preencherAnoCorPorPlaca(placa) {
    const p = (placa || '').toUpperCase().trim();
    const limpa = p.replace(/[^A-Z0-9]/g, '');

    // placa no BR costuma ter 7 chars (AAA1A11 / AAA1234)
    if (limpa.length < 7) return;

    const resp = await veiculoService.consultarDadosCadastrais(p);
    if (resp?.error) return;

    setVistoria((old) => ({
      ...old,
      ano: old?.ano ?? resp.anoModelo ?? null,
      cor: old?.cor ?? resp.cor ?? null,
    }));
  }
  const downloadDocument = async () => {
    await printDocument();

    const content = inputRef.current;

    content.style.marginLeft = '0px';
    content.style.marginRight = '0px';
  }

  const printDocument = async () => {
    const marginLeft = 50;
    const marginRight = 50;

    const options = {
      filename: `${'Vistoria - NA' + ordemServico?.na}.pdf`,
      image: { type: 'jpeg', quality: 1 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' },
    };

    const content = inputRef.current;
    content.style.marginLeft = `${marginLeft}px`;
    content.style.marginRight = `${marginRight}px`;
    content.style.paddingTop = '120px';

    const worker = html2pdf().from(content).set(options);

    worker.toPdf().get('pdf').then(function (pdf) {
      const totalPages = pdf.internal.getNumberOfPages();
      const pageWidth = pdf.internal.pageSize.getWidth();

      pdf.setPage(1);

      pdf.addImage(URL_WAVE, 'PNG', 0, 0, pageWidth, 70);
      pdf.addImage(URL_LOGO, 'PNG', 45, 45, 150, 40);

      pdf.setFontSize(16);
      pdf.setTextColor(255, 255, 255);
      pdf.text('NA ' + ordemServico?.na, pageWidth - 50, 40, { align: 'right' });

      for (let i = 2; i <= totalPages; i++) {
        pdf.setPage(i);
      }
    }).then(function () {
      worker.save();
      content.style.paddingTop = '0px';
    });
  };

  // busca os dados da vistoria a partir da OS passada
  async function getVistoria() {
    try {
      setLoadVistoria(true);
      const { osID, activityId } = ordemServico;

      const responseVistoria = await vistoriaService.consultaVistoria(
        activityId,
        osID
      );
      if (responseVistoria?.error) {
        setMensagemAlert(responseVistoria?.message);
        setAbrirAlert(true);
      } else {
        if (responseVistoria) {
          setVistoria(responseVistoria);
          setEditVistoria(true);
          if (responseVistoria.entrada) setDisabledEditEntry(true);
          if (responseVistoria.saida) setDisabledEditExit(true);
        } else {
          setEditVistoria(false);
        }
      }
    } catch (error) {
      console.log(error.toString());
    } finally {
      setLoadVistoria(false);
    }
  }

  // ativada sempre que alterar um dado de input
  const handleInputChange = (atr, value) => {
    setVistoria((checkList) => ({
      ...checkList,
      [atr]: value,
    }));
  };

  // verifica o valor passado e limita à 4 digitos
  function onChangeYear(value) {
    if (!value) {
      setVistoria((oldVistoria) => ({
        ...oldVistoria,
        ano: null,
      }));
      return;
    }
    if (value?.length <= 4) {
      setVistoria((oldVistoria) => ({
        ...oldVistoria,
        ano: value >= 0 ? parseInt(value) : parseInt(value) * -1,
      }));
    }
  }

  // converte o valor para boolean
  const parseBool = (value) =>
    value === 'true' || value === true ? true : false;

  return (
    <div style={{ margin: 30 }}>
      <div id="divToPrint">
        <h3 className={classes.tituloStyle}>Vistoria</h3>
        <h4 className={classes.subtituloStyle}>
          <span
            onClick={() => {
              const userInfo = authService.getUserInfo();
              if (userInfo.usuario.gestor) {
                window.location.assign('/gestor');
              } else {
                window.location.assign('/agenda');
              }
            }}
            className={classes.linkStyle}
            style={{ cursor: 'pointer' }}
          >
            Home
          </span>
          {' > '}
          Serviços
          {' > '}
          Vistoria
          {authService.getUserInfo().usuario.gestor === true &&
            nomeTecnico &&
            nomeTecnico.trim() !== '' ? (
            <>
              {' > '}
              {nomeTecnico}
            </>
          ) : null}
        </h4>

        <Grid className={classes.actions} container alignItems="center">
          <Grid item xs={3} sm={2} md={1}>
            <Button
              fullWidth
              onClick={handleBack}
              style={{ color: '#209BDE' }}
              startIcon={<ArrowBackIos />}
            >
              Voltar
            </Button>
          </Grid>
        </Grid>

        <Paper className={classes.paper} >
          {loadVistoria ? (
            <Grid container alignItems="center" justifyContent="center">
              <CircularProgress style={{ color: '#209BDE' }} />
            </Grid>
          ) : (
            <>
              <BlueButton
                fullWidth
                onClick={downloadDocument}
                startIcon={<PictureAsPdfIcon />}
              >
                DOWNLOAD PDF
              </BlueButton>
              <div className={classes.title}>Vistoria</div>
              <Divider />
              <div ref={inputRef}>
                <div className={classes.subtitle}>
                  Informações sobre instalação
                </div>

                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={4}>
                    <Typography variant="subtitle1">Equipamento:</Typography>
                    <TextField
                      required
                      id="txtEquipamento"
                      error={!!errors.equipamento}
                      helperText={errors.equipamento?.message}
                      value={ordemServico?.rastreador || vistoria?.equipamento || ''}
                      fullWidth
                      onChange={(event) =>
                        handleInputChange('equipamento', event.target.value)
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                      variant="outlined"
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <Typography variant="subtitle1">Número de Série/ID:</Typography>
                    <TextField
                      fullWidth
                      required
                      error={!!errors.serie}
                      helperText={errors.serie?.message}
                      id="txtNumSerie"
                      value={vistoria?.serie || ordemServico?.num_serie_contrato || ''}
                      onChange={(event) =>
                        handleInputChange('serie', event.target.value)
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                      variant="outlined"
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <Typography variant="subtitle1">NA:</Typography>
                    <TextField
                      fullWidth
                      id="txtNA"
                      value={vistoria?.na || ordemServico?.na || ''}
                      disabled
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <Typography variant="subtitle1">OS:</Typography>
                    <TextField
                      fullWidth
                      id="txtOS"
                      value={vistoria?.numeroOS || ordemServico?.os || ''}
                      disabled
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <Typography variant="subtitle1">Antena Sat:</Typography>
                    <TextField
                      fullWidth
                      id="txtAntena"
                      value={ordemServico?.antena || ''}
                      disabled
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <Typography variant="subtitle1">Instalador e Auxiliar:</Typography>
                    <TextField
                      fullWidth
                      id="txtInstalador"
                      value={vistoria?.instalador || ''}
                      variant="outlined"
                      disabled
                    />
                  </Grid>
                </Grid>

                <div className={classes.subtitle}>
                  Tipo de serviço
                </div>

                {!!errors.tipo_servico && (
                  <span className={classes.errorText} style={{ marginTop: 20 }}>
                    {errors.tipo_servico.message}
                  </span>
                )}

                <RadioGroup
                  row
                  id="rdpgTipoVeiculo"
                  value={vistoria?.tipo_servico || ordemServico?.tipoServico || ''}
                  onChange={(event) =>
                    handleInputChange('tipo_servico', event.target.value)
                  }
                  style={{ marginTop: errors.tipo_servico ? 2 : 20 }}
                >
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={4} md={4}>
                      <FormControlLabel
                        value="IR"
                        control={<Radio color="primary" />}
                        label="Instalação/Reinstalação"
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={4}>
                      <FormControlLabel
                        value="RM"
                        control={<Radio color="primary" />}
                        label="Revisão/Manutenção"
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={2}>
                      <FormControlLabel
                        value="RT"
                        control={<Radio color="primary" />}
                        label="Retirada"
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} sm={4} md={2}>
                      <FormControlLabel
                        value="UP"
                        control={<Radio color="primary" />}
                        label="Upgrade"
                        disabled
                      />
                    </Grid>
                  </Grid>
                </RadioGroup>

                <div className={classes.subtitle}>Dados do cliente e veículo</div>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle1">Cliente:</Typography>
                    <TextField
                      fullWidth
                      id="txtCliente"
                      value={ordemServico?.cliente || ''}
                      disabled
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle1">Local do serviço:</Typography>
                    <FormControl
                      variant="outlined"
                      fullWidth
                      required
                      error={!!errors.local_servico}
                    >
                      <Select
                        native
                        labelId="label_local"
                        disabled
                        id="select_local"
                        value={
                          locais.includes(vistoria?.local_servico?.trim())
                            ? vistoria?.local_servico
                            : ''
                        }
                        onChange={(event) =>
                          handleInputChange('local_servico', event.target.value)
                        }
                      >
                        <optgroup>
                          <option value="" disabled hidden />
                          {locais.map((local) => (
                            <option key={local} value={local}>
                              {local}
                            </option>
                          ))}
                        </optgroup>
                      </Select>
                      <FormHelperText>{errors.local_servico?.message}</FormHelperText>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <Typography variant="subtitle1">Placa:</Typography>
                    <TextField
                      required
                      fullWidth
                      error={!!errors.placa}
                      helperText={errors.placa?.message}
                      id="txtPlaca"
                      value={vistoria?.placa || ordemServico?.placa || ''}
                      onChange={(event) => handleInputChange('placa', event.target.value)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <Typography variant="subtitle1">Ano:</Typography>
                    <TextField
                      required
                      fullWidth
                      error={!!errors.ano}
                      helperText={errors.ano?.message}
                      id="txtAno"
                      type="number"
                      value={vistoria?.ano || ''}
                      onChange={(event) => onChangeYear(event.target.value)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 4 }}
                      variant="outlined"
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <Typography variant="subtitle1">Cor:</Typography>
                    <TextField
                      required
                      fullWidth
                      error={!!errors.cor}
                      helperText={errors.cor?.message}
                      id="txtCor"
                      value={vistoria?.cor || ordemServico?.cor || ''}
                      onChange={(event) => handleInputChange('cor', event.target.value)}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      variant="outlined"
                      disabled
                    />
                  </Grid>
                  {classificacaoPrestador !== 2 && (
                    <Grid item xs={12}>
                      <Typography variant="subtitle1">Observações do Cliente:</Typography>
                      <TextField
                        id="txtObsAgendamento"
                        fullWidth
                        value={ordemServico?.observacao || ''}
                        onChange={(event) => handleInputChange('observacao', event.target.value)}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        variant="outlined"
                        disabled
                        multiline
                      />
                    </Grid>
                  )}
                </Grid>

                <Grid container spacing={2} style={{ marginTop: 35 }}>
                  <Grid item xs={12} sm={4} md={3}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          id="chkMecanico"
                          name="chkMecanico"
                          checked={parseBool(vistoria?.mecanico)}
                          value={vistoria?.mecanico || ''}
                          onChange={(event) =>
                            handleInputChange(
                              'mecanico',
                              !parseBool(event.target.value)
                            )
                          }
                        />
                      }
                      label="Mecânico"
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          id="chkInjecao"
                          name="chkInjecao"
                          checked={parseBool(vistoria?.injecao_eletronica)}
                          value={vistoria?.injecao_eletronica || ''}
                          onChange={(event) =>
                            handleInputChange(
                              'injecao_eletronica',
                              !parseBool(event.target.value)
                            )
                          }
                        />
                      }
                      label="Injeção Eletrônica"
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          id="chkDoze"
                          name="chkDoze"
                          checked={parseBool(vistoria?.doze_v)}
                          value={vistoria?.doze_v || ''}
                          onChange={(event) =>
                            handleInputChange(
                              'doze_v',
                              !parseBool(event.target.value)
                            )
                          }
                        />
                      }
                      label="12V"
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          id="chk24V"
                          name="chk24V"
                          checked={parseBool(vistoria?.vinte_quatro_v)}
                          value={vistoria?.vinte_quatro_v || ''}
                          onChange={(event) =>
                            handleInputChange(
                              'vinte_quatro_v',
                              !parseBool(event.target.value)
                            )
                          }
                        />
                      }
                      label="24V"
                      disabled
                    />
                  </Grid>
                </Grid>

                <div className={classes.subtitle}>Tipo do veículo</div>
                {!!errors.tipo_veiculo && (
                  <span className={classes.errorText}>
                    {errors.tipo_veiculo.message}
                  </span>
                )}
                <RadioGroup
                  row
                  id="rdpgTPVeiculo"
                  value={vistoria?.tipo_veiculo || ''}
                  onChange={(event) =>
                    handleInputChange('tipo_veiculo', event.target.value)
                  }
                >
                  <Grid container>
                    <Grid item xs={12} sm={3}>
                      <FormControlLabel
                        value="CM"
                        control={<Radio color="primary" />}
                        label="Cavalo Mec."
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <FormControlLabel
                        value="TR"
                        control={<Radio color="primary" />}
                        label="Truck"
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <FormControlLabel
                        value="TC"
                        control={<Radio color="primary" />}
                        label="Toco"
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <FormControlLabel
                        value="VN"
                        control={<Radio color="primary" />}
                        label="Van"
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <FormControlLabel
                        value="PS"
                        control={<Radio color="primary" />}
                        label="Passeio"
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <FormControlLabel
                        value="MT"
                        control={<Radio color="primary" />}
                        label="Moto"
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <FormControlLabel
                        value="CT"
                        control={<Radio color="primary" />}
                        label="Caminhonete"
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <FormControlLabel
                        value="ON"
                        control={<Radio color="primary" />}
                        label="Ônibus"
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <FormControlLabel
                        value="CR"
                        control={<Radio color="primary" />}
                        label="Carreta"
                        disabled
                      />
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <FormControlLabel
                        value="LA"
                        control={<Radio color="primary" />}
                        label="Linha amarela"
                        disabled
                      />
                    </Grid>
                  </Grid>
                </RadioGroup>

                {vistoria?.tipo_veiculo === 'CR' && (
                  <>
                    <div className={classes.subtitle}>Dados da carreta</div>
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <strong>Tipo da carreta: </strong>
                        <RadioGroup
                          row
                          id="rdpgTPCarreta"
                          value={vistoria?.tipo_carreta || ''}
                          onChange={(event) =>
                            handleInputChange('tipo_carreta', event.target.value)
                          }
                        >
                          <Grid container>
                            <Grid item xs={12} sm={3}>
                              <FormControlLabel
                                value="CS"
                                control={<Radio color="primary" />}
                                label="Carga Seca"
                                disabled
                              />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                              <FormControlLabel
                                value="BA"
                                control={<Radio color="primary" />}
                                label="Baú Alumínio"
                                disabled
                              />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                              <FormControlLabel
                                value="BR"
                                control={<Radio color="primary" />}
                                label="Baú Refrig."
                                disabled
                              />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                              <FormControlLabel
                                value="BG"
                                control={<Radio color="primary" />}
                                label="BUG"
                                disabled
                              />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                              <FormControlLabel
                                value="TR"
                                control={<Radio color="primary" />}
                                label="Treminhão"
                                disabled
                              />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                              <FormControlLabel
                                value="SD"
                                control={<Radio color="primary" />}
                                label="Sider"
                                disabled
                              />
                            </Grid>
                            <Grid item xs={12} sm={3}>
                              <FormControlLabel
                                value="PL"
                                control={<Radio color="primary" />}
                                label="Plataforma"
                                disabled
                              />
                            </Grid>
                          </Grid>
                        </RadioGroup>
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                        <TextField
                          fullWidth
                          id="txtPlacaCarreta"
                          label="Placa da Carreta"
                          value={vistoria?.placa_carreta || ''}
                          onChange={(event) =>
                            handleInputChange('placa_carreta', event.target.value)
                          }
                          InputLabelProps={{
                            shrink: true,
                          }}
                          variant="outlined"
                          disabled
                        />
                      </Grid>
                    </Grid>
                  </>
                )}

                <div className="html2pdf__page-break"></div>
                <div className={classes.title}>
                  Vistoria do veículo
                </div>
                <Divider />

                <AvlPreliminarVistoria
                  vistoria={vistoria}
                  handleInputChange={handleInputChange}
                  classes={classes}
                  errors={errors}
                  disabled
                />

                {/* IMAGENS DE VEICULOS */}
                <AvlLatariaVistoria
                  vistoria={vistoria}
                  handleInputChange={handleInputChange}
                  parseBool={parseBool}
                  classes={classes}
                  disabled
                />

                {/* CHECKLIST - ITENS */}
                <VistoriaItems
                  vistoria={vistoria}
                  handleInputChange={handleInputChange}
                  classes={classes}
                  errors={errors}
                  disabled
                />

                <div className="html2pdf__page-break"></div>
                {/* CHECKLIST - PRODUTOS & SERVIÇOS */}
                <ListaProdutosServicos
                  na={ordemServico.na}
                  itensOS={itensOS}
                  vistoria={vistoria}
                  handleInputChange={handleInputChange}
                  classes={classes}
                  errors={errors}
                  disabledEditEntry={disabledEditEntry}
                  disabledEditExit={disabledEditExit}
                />

                <div className="html2pdf__page-break"></div>
                <div className={classes.subtitle}>
                  Dados do Cliente -  Aprovação
                </div>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle1">Nome do conferente:</Typography>
                    <TextField
                      required
                      fullWidth
                      id="NomeClienteVistoria "
                      value={vistoria?.clienteNome || ''}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(event) =>
                        handleInputChange('NomeClienteVistoria ', event.target.value)
                      }
                      variant="outlined"
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography variant="subtitle1">CPF do conferente:</Typography>
                    <TextField
                      fullWidth
                      id="cpf_rg"
                      value={vistoria?.clienteCpfCnpj || ''}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      variant="outlined"
                      disabled
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <Typography variant="subtitle1">Observações da Vistoria:</Typography>
                    <TextField
                      id="txtObs"
                      fullWidth
                      value={vistoria?.observacao || ''}
                      onChange={(event) =>
                        handleInputChange('observacao', event.target.value)
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                      variant="outlined"
                      disabled
                    />
                  </Grid>
                  {vistoria?.entrada && (
                    <Grid item xs={12}>
                      <Typography variant="subtitle1">Resumo do Serviço:</Typography>
                      <TextField
                        id="txtObs"
                        fullWidth
                        value={vistoria?.resumo_servico || ''}
                        style={{ width: '100%' }}
                        onChange={(event) =>
                          handleInputChange('resumo_servico', event.target.value)
                        }
                        InputLabelProps={{
                          shrink: true,
                        }}
                        variant="outlined"
                        disabled
                      />
                    </Grid>
                  )}
                </Grid></div>
            </>
          )}
        </Paper>
      </div>
    </div>
  );
}
